import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center serif-display text-navy/60" data-testid="protected-loading">Checking access…</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children || <Outlet />;
}
